import * as React from 'react';
import theme from './CompanionGroup.module.css';
const CompanionGroup = ({ companion, optionRender }) => {
    return (React.createElement("div", { key: companion.label.toLocaleString(), className: theme.root },
        React.createElement("div", { className: theme.name }, companion.label),
        companion.options.map(optionRender)));
};
export default CompanionGroup;
